export const updateActiveSlide = ({ activeSlide }) => ({
	type: "UPDATE_ACTIVE_SLIDE",
	activeSlide,
});

export const updateSlides = ({ slides }) => ({
	type: "UPDATE_SLIDES",
	slides,
});
